import { getApp } from 'firebase/app'
import { doc, getFirestore, onSnapshot } from 'firebase/firestore'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { mediacoreApi } from '@apis/mediacoreApi'

type Tags = Parameters<typeof mediacoreApi.util.invalidateTags>[0]

export const useFirestoreInvalidation = (clientId: number | undefined, field: string, tags: Tags) => {
  const dispatch = useDispatch()
  const isFirstRef = useRef(true)
  const prevValueRef = useRef<string | null>(null)

  useEffect(() => {
    if (!clientId) return
    isFirstRef.current = true
    prevValueRef.current = null
    const db = getFirestore(getApp(), 'realtime')
    const environment = process.env.GATSBY_ENVIRONMENT || 'local'
    const unsubscribe = onSnapshot(doc(db, `invalidations-${environment}`, String(clientId)), (snapshot) => {
      const newValue = (snapshot.data()?.[field] as { last_updated?: string } | undefined)?.last_updated ?? null
      if (isFirstRef.current) {
        isFirstRef.current = false
        prevValueRef.current = newValue
        return
      }
      if (newValue !== prevValueRef.current) {
        prevValueRef.current = newValue
        dispatch(mediacoreApi.util.invalidateTags(tags))
      }
    })
    return unsubscribe
  }, [clientId])
}
